module.exports = __webpack_public_path__ + "img/calendar2-date.974163d6.svg";